export default __webpack_public_path__ + "static/media/gallery-2.c6d7c635.jpg";